export default [
  {
    path: "/caseHandledList",
    component: () =>
      import(
        /* webpackChunkName: "casesHandled" */ "@/views/casesHandled/list"
      ),
    name: "caseHandledList",
    meta: {
      isTab: true,
      keepAlive: false,
      links: ["已受理"],
      permissionsPath: "/caseHandledList"
    }
  },
  {
    path: "/reportUpload",
    component: () =>
      import(
        /* webpackChunkName: "casesHandled" */ "@/views/casesHandled/reportUpload"
      ),
    name: "reportUpload",
    meta: {
      isTab: true,
      keepAlive: false,
      links: ["报告上传"],
      permissionsPath: "/caseHandledList"
    }
  }
];
